import { useRef, useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

function DateInput({ label, onChange, value }) {
  const [date, setDate] = useState(value || null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    setDate(value || null);
  }, [value]);

  const handleChange = (e) => {
    if (!e) {
      setDate(null);
      onChangeRef.current?.(null);
      return;
    }
    const newDate = new Date(e).toISOString();
    setDate(newDate);
    onChangeRef.current?.(newDate);
  };

  const handleClear = (ev) => {
    ev.stopPropagation();
    setDate(null);
    onChangeRef.current?.(null);
  };

  return (
    <div className="flex flex-col">
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label || ""}
      </label>
      <div className="relative">
        <DatePicker
          format="MM-DD-YYYY HH:mm:ss"
          value={date}
          onChange={handleChange}
          calendar={persian}
          inputClass={`p-2.5 rounded-lg border text-center bg-gray-50 dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm focus:ring-blue-500 focus:border-blue-500 w-full ${date ? "pl-7" : ""}`}
          containerStyle={{ width: "100%" }}
          locale={persian_fa}
          calendarPosition="bottom-right"
          portal
          plugins={[
            <TimePicker position="bottom" hStep={2} mStep={3} sStep={4} />,
          ]}
        />
        {date && (
          <button
            type="button"
            onMouseDown={handleClear}
            className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 text-base leading-none z-10"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}

export default DateInput;
